<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'" [cardOptionBtn]="true" [cardRouterLink]="'/back-office/parts/add'" [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" (click)="goToArchive()" type="button">{{'global.view_archive'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'part'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="partName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #addStockModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.parts.add_stock'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="addStockModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addStockForm="ngForm">
      <div class="row">
        <div class="form-group col-md-5">
          <label [for]="'articleName'">{{'admin.parts.add_stock_amount' | translate}}<span
            class="star">*</span></label>
          <input required
                  pattern="\d+([.]\d(\d)?(\d)?)?"
                  min="1"
                  [name]="'newStocksForPart'"
                  [id]="'newStocksForPart'"
                  class="form-control"
                  #newStocksForPart="ngModel"
                  type="number"
                [(ngModel)]="newStocksForPart">
          <span class="form-bar"></span>
          <div class="messages text-danger"
                *ngIf="newStocksForPart.invalid && newStocksForPart.dirty && newStocksForPart.errors?.required">
            {{'errors.required'|translate}}
          </div>
          <div class="messages text-danger"
                *ngIf="newStocksForPart.invalid && newStocksForPart.dirty && (newStocksForPart.errors?.pattern || newStocksForPart.errors.min || newStocksForPart.errors.max)">
            {{'errors.invalid'|translate}}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="addStockModal.hide()">{{'global.cancel'|translate}}</button>
    <button class="btn btn-primary ripple light" type="button"
            (click)="addStockValue(addStockForm)" [disabled]="!addStockForm.valid">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>

<app-modal-basic #viewModal [dialogClass]="'modal-lg'" [hideOnClickOutside]="true">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.part.show.add.part'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="viewModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body" *ngIf="viewPartData">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <b>{{'doctrine.part.name'|translate}}</b>
          <div class="form-control-static">{{viewPartData.name}}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <b>{{'doctrine.part.code'|translate}}</b>
          <div class="form-control-static">{{viewPartData.code}}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <b>{{'doctrine.part.stockAmount'|translate}}</b>
          <div class="form-control-static">{{viewPartData.stockAmount}}</div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <b>{{'doctrine.part.openOrdersAmount'|translate}}</b>
          <div class="form-control-static">{{viewPartData.openOrdersAmount}}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <b>{{'doctrine.part.freeStockAmount'|translate}}</b>
          <div class="form-control-static">{{viewPartData.freeStockAmount}}</div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="viewPartData.supplierPart">
      <hr>
      
      <div class="row" *ngIf="viewPartData.supplierPart">
        <div class="col-md-4">
          <div class="form-group">
            <b>{{'doctrine.part.supplierName'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.name}}</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <b>{{'doctrine.part.contactPerson'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.contactPerson}}</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <b>{{'doctrine.part.email'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.email}}</div>
          </div>
        </div>
      </div>
      
      <div class="row" *ngIf="viewPartData.supplierPart">
        <div class="col-md-4">
          <div class="form-group">
            <b>{{'doctrine.part.supplierPartName'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.supplierPartName}}</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <b>{{'doctrine.part.supplierPartCode'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.supplierPartCode}}</div>
          </div>
        </div>
      </div>
      
      <div class="row" *ngIf="viewPartData.supplierPart && viewPartData.supplierPart.remark">
        <div class="col-md-12">
          <div class="form-group">
            <b>{{'doctrine.part.remark'|translate}}</b>
            <div class="form-control-static">{{viewPartData.supplierPart.remark}}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="app-modal-footer d-flex gap-2">
    <button type="button" class="btn btn-outline-primary ripple light" (click)="editPart()">{{'global.actions.edit'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="viewModal.hide()">{{'global.close'|translate}}</button>
  </div>
</app-modal-basic>
